module.exports = __webpack_public_path__ + "img/crop5_active.ff0fe73a.png";